import React from "react";
import styled from "styled-components";

export default function TwitterDescription() {
  return (
    <ul>
      <ListItem>
        <b>Self-Designed Interface: </b> Every aspect of this portfolio’s design
        is crafted by me, reflecting my aesthetic vision and attention to
        detail.
      </ListItem>
      <ListItem>
        <b>
          Built with React, this portfolio demonstrates my ability to create
          dynamic and interactive user interfaces using one of the most popular
          JavaScript libraries.
        </b>
      </ListItem>
    </ul>
  );
}

const ListItem = styled.li`
  list-style-type: none;
`;
